/* @flow */

import * as React from 'react';

import {Button} from 'shells/button';
import {colors} from 'shells/colors';
import {StackLegacy} from 'shells/layout';
import {ProgressBar} from 'shells/progress-bar';
import {Body} from 'shells/typography';

import './tiny-introduction-wrapper.module.css';

type Props = {
    onBack?: () => void,
    children: React.Node,
    progress: number,
};

export class TinyIntroductionWrapper extends React.PureComponent<Props> {
    render() {
        return (
            <div styleName='tiny-introduction-wrapper'>
                {this.props.progress !== 1 && (
                    <StackLegacy isFullWidth={true} spacing={16}>
                        <Body color='medium'>Step {getProgressStep(this.props.progress)} of 3</Body>
                        <div styleName='progress-bar-container-new'>
                            <ProgressBar
                                height={5}
                                color={colors.blueDk}
                                percentComplete={this.props.progress}
                                roundedCorners={true}
                                backgroundColor='#d9d9d9'
                            />
                        </div>
                    </StackLegacy>
                )}
                {this.props.children}
                {this.props.onBack ? (
                    <div styleName='small-screen-back-button'>
                        <Button variant='text-secondary' onClick={this.handleBack}>
                            Previous
                        </Button>
                    </div>
                ) : undefined}
            </div>
        );
    }

    handleBack = () => {
        if (this.props.onBack) {
            this.props.onBack();
        }
    };
}

function getProgressStep(progress: number): string {
    if (progress === 0.33) {
        return '1';
    } else if (progress === 0.66) {
        return '2';
    } else {
        return '3';
    }
}
